import { render } from "./Previous.vue?vue&type=template&id=77229892"
import script from "./Previous.vue?vue&type=script&lang=js"
export * from "./Previous.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./style.scss?vue&type=style&index=0&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__